/* Theme custom file */
class CountdownBar extends HTMLElement {
  connectedCallback() {
    this.labelEl = this.querySelector('[data-countdown-label]');
    this.timeEl = this.querySelector('[data-countdown-time]');
    this.targetTimestamp = parseInt(this.dataset.target, 10) * 1000;
    this.almostThereLabel = this.dataset.almostThere || '';
    this.status = this.dataset.status || '';

    if (!this.labelEl || !this.timeEl || !this.targetTimestamp) return;

    if (this.targetTimestamp <= Date.now()) {
      this.hidden = true;
      return;
    }

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  update() {
    const remaining = this.targetTimestamp - Date.now();

    if (remaining <= 0) {
      this.handleExpired();
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');

    this.timeEl.textContent = `${hours}:${minutes}:${seconds}`;
  }

  handleExpired() {
    clearInterval(this.interval);

    if (this.status === 'upcoming') {
      this.labelEl.textContent = this.almostThereLabel;
      this.timeEl.textContent = '';
      setTimeout(() => window.location.reload(), 5000);
    } else {
      this.hidden = true;
      setTimeout(() => window.location.reload(), 3000);
    }
  }
}

customElements.define('countdown-bar', CountdownBar);
